import {setToken, setRefreshToken, removeToken, removeRefreshToken} from '@/util/auth'
import {setStore, getStore} from '@/util/store'
import {isURL, validatenull} from '@/util/validate'
import {mobileRouters} from "@/api/dict";
// import {deepClone} from '@/util/util'
import website from '@/config/website'
import {loginByUsername, loginBySocial, getUserInfo, logout, refreshToken, getButtons,loginByPassword, getUsertenant,loginByPhone} from '@/api/user'
import md5 from 'js-md5'
import {encryptByAES} from "@/util/cryptoutils";
// 引入提示
import Vue from 'vue';
import { Toast } from 'vant';
Vue.use(Toast);

function addPath(ele, first) {
  const menu = website.menu;
  const propsConfig = menu.props;
  const propsDefault = {
    label: propsConfig.label || 'name',
    path: propsConfig.path || 'path',
    icon: propsConfig.icon || 'icon',
    children: propsConfig.children || 'children'
  }
  const icon = ele[propsDefault.icon];
  ele[propsDefault.icon] = validatenull(icon) ? menu.iconDefault : icon;
  const isChild = ele[propsDefault.children] && ele[propsDefault.children].length !== 0;
  if (!isChild) ele[propsDefault.children] = [];
  if (!isChild && first && !isURL(ele[propsDefault.path])) {
    ele[propsDefault.path] = ele[propsDefault.path] + '/index'
  } else {
    ele[propsDefault.children].forEach(child => {
      addPath(child);
    })
  }

}

const user = {
  state: {
    tenantId: getStore({name: 'tenantId'}) || '',
    userInfo: getStore({name: 'userInfo'}) || [],
    permission: getStore({name: 'permission'}) || {},
    roles: [],
    menu: getStore({name: 'menu'}) || [],
    menuId: getStore({name: 'menuId'}) || [],
    menuAll: getStore({name: 'menuAll'}) || [],
    token: getStore({name: 'token'}) || '',
    refreshToken: getStore({name: 'refreshToken'}) || '',
    userTenantList: getStore({name: 'userTenantList'}) || '',
    currUserTenant: getStore({name: 'currUserTenant'}) || '',
    lastOperationTime: getStore({name: 'lastOperationTime'}) || '',
  },
  actions: {
    //根据用户名登录
    LoginByUsername({commit}, userInfo) {
      return new Promise((resolve, reject) => {
        loginByUsername(userInfo.tenantId, userInfo.username, encryptByAES(md5(userInfo.password), "Ono9I/JrWJBIMM16Qkel0g=="), userInfo.type, userInfo.key, userInfo.code).then(res => {
          const data = res.data;
          if (data.error_description) {
            Toast.fail(data.error_description)
          } else {
            commit('SET_TOKEN', data.access_token);
            commit('SET_REFRESH_TOKEN', data.refresh_token);
            commit('SET_TENANT_ID', data.tenant_id);
            commit('SET_USER_INFO', data);
            commit('DEL_ALL_TAG');
            commit('CLEAR_LOCK');
            commit('SET_AREA_CODE', data.region_code)
            setStore({name:"lastOperationTime", content: new Date().getTime()})
          }
          resolve();
        }).catch(error => {
          Toast(error.toString())
          reject(error);
        })
      })
    },
    loginByPassword({commit},loginInfo) {
      console.log(loginInfo, "loginInfo-->");
      return new Promise((resolve, reject) => {
        loginByPassword(loginInfo.t, loginInfo.u, loginInfo.p).then(res => {
          if (!res){
            reject();
          } else {
            const data = res.data;
            if (data.error_description) {
              Toast.fail(data.error_description)
            } else {
              commit('SET_TOKEN', data.access_token);
              commit('SET_REFRESH_TOKEN', data.refresh_token);
              commit('SET_TENANT_ID', data.tenant_id);
              commit('SET_USER_INFO', data);
              commit('DEL_ALL_TAG');
              commit('CLEAR_LOCK');
              commit('SET_AREA_CODE', data.region_code)
              setStore({name:"lastOperationTime", content: new Date().getTime()})
            }
            resolve();
          }
        }).catch(error => {
          Toast(error.toString())
          reject(error);
        })
      })
    },
    //根据手机号登录
    LoginByPhone({commit}, userInfo) {
      return new Promise((resolve,reject) => {
        loginByPhone(userInfo.username, userInfo.code, userInfo.key, md5(userInfo.password)).then(res => {
          const data = res.data;
          if (data.error_description) {
            Toast.fail(data.error_description)
          } else {
            commit('SET_TOKEN', data.access_token);
            commit('SET_REFRESH_TOKEN', data.refresh_token);
            commit('SET_TENANT_ID', data.tenant_id);
            commit('SET_USER_INFO', data);
            commit('DEL_ALL_TAG');
            commit('CLEAR_LOCK');
            commit('SET_AREA_CODE', data.region_code)
            setStore({name:"lastOperationTime", content: new Date().getTime()})
          }
          resolve();
          resolve();
        }).catch(error => {
          Toast(error.toString())
          reject(error);
        })
      })
    },
    //根据第三方信息登录
    LoginBySocial({commit}, userInfo) {
      return new Promise((resolve) => {
        loginBySocial(userInfo.tenantId, userInfo.source, userInfo.code, userInfo.state).then(res => {
          const data = res.data;
          if (data.error_description) {
            this.$toast.fail(data.error_description)
          } else {
            // commit('SET_TOKEN', data.access_token);
            // commit('SET_REFRESH_TOKEN', data.refresh_token);
            // commit('SET_USER_INFO', data);
            // commit('DEL_ALL_TAG');
            // commit('CLEAR_LOCK');
            // if(data.region_code) {
            //   commit('SET_AREA_CODE', data.region_code)
            // }
            commit('SET_TOKEN', data.access_token);
            commit('SET_REFRESH_TOKEN', data.refresh_token);
            commit('SET_TENANT_ID', data.tenant_id);
            commit('SET_USER_INFO', data);
            commit('DEL_ALL_TAG');
            commit('CLEAR_LOCK');
            commit('SET_AREA_CODE', data.area_code)
            setStore({name:"lastOperationTime", content: new Date().getTime()})
          }
          resolve(data.access_token);

        })
      })
    },
    //获取用户信息
    GetUserInfo({commit}) {
      return new Promise((resolve, reject) => {
        getUserInfo().then((res) => {
          const data = res.data.data;
          // commit('SET_ROLES', data.roles);
          resolve(data);
        }).catch(err => {
          reject(err);
        })
      })
    },
    //刷新token
    refreshToken({state, commit}) {
      window.console.log('handle refresh token')
      return new Promise((resolve, reject) => {
        refreshToken(state.refreshToken, state.tenantId).then(res => {
          const data = res.data;
          commit('SET_TOKEN', data.access_token);
          commit('SET_REFRESH_TOKEN', data.refresh_token);
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },
    // 登出
    LogOut({commit}) {
      return new Promise((resolve, reject) => {
        logout().then(() => {
          commit('SET_TOKEN', '');
          commit('SET_REFRESH_TOKEN', '');
          commit('DEL_ALL_TAG');
          commit('CLEAR_LOCK');
          commit('SET_AREA_CODE', '')
          setStore({name: 'userTenantList', content: ''})
          setStore({name: 'currUserTenant', content: ''})
          setStore({name: 'userTenant', content: ''})
          setStore({name:"menuAll", content: ''})
          setStore({name:"menu", content: ''})
          setStore({name:"lastOperationTime", content: ""})
          localStorage.setItem("t","")
          localStorage.setItem("u","")
          localStorage.setItem("p","")

          removeToken();
          removeRefreshToken();
          resolve();
        }).catch(error => {
          reject(error)
        })
      })
    },
    //注销session
    FedLogOut({commit}) {
      return new Promise(resolve => {
        commit('SET_TOKEN', '');
        commit('SET_REFRESH_TOKEN', '');
        commit('DEL_ALL_TAG');
        commit('CLEAR_LOCK');
        commit('SET_AREA_CODE', '')
        setStore({name: 'userTenantList', content: ''})
        setStore({name: 'currUserTenant', content: ''})
        setStore({name:"menuAll", content: ''})
        setStore({name:"menu", content: ''})
        setStore({name:"freshTime", content: ''})
        setStore({name:"lastOperationTime", content: null})
        removeToken();
        removeRefreshToken();
        resolve();
      })
    },
    //获取系统按钮
    GetButtons({commit}) {
      return new Promise((resolve) => {
        getButtons().then(res => {
          const data = res.data.data;
          commit('SET_PERMISSION', data);
          resolve();
        })
      })
    },
    GetRoleMenu({commit}){
      return new Promise((resolve,reject) => {
        mobileRouters().then(res => {
          if (res && res.data){
            const data = res.data.data || [];
            commit('SET_MENU', data);
            if (res.data.success){
              resolve(data);
            } else {
              reject("获取菜单权限失败");
            }
          } else {
            resolve([]);
          }

        });
      });
    },
    // 获取项目角色
    GetUsertenant({commit}) {
      return new Promise((resolve) => {
        getUsertenant().then(res => {
          const data = res.data.data
          commit('SET_USER_TENANT', data)
          resolve()
        })
      })
    }
  },
  mutations: {
    SET_TOKEN: (state, token) => {
      setToken(token);
      state.token = token;
      setStore({name: 'token', content: state.token})
    },
    SET_MENU_ID(state, menuId) {
      state.menuId = menuId;
      setStore({name: 'menuId', content: state.menuId})
    },
    SET_MENU_ALL: (state, menuAll) => {
      state.menuAll = menuAll
      setStore({name: 'menuAll', content: state.menuAll})
    },
    SET_MENU: (state, menu) => {
      state.menu = menu
      setStore({name: 'menu', content: state.menu})
      if (validatenull(menu)) return;
      //合并动态路由去重
      let menuAll = state.menuAll;
      menuAll = menuAll.concat(menu).reverse();
      let newMenu = [];
      for (let item1 of menuAll) {
        let flag = true;
        for (let item2 of newMenu) {
          if (item1.name === item2.name || item1.path === item2.path) {
            flag = false;
          }
        }
        if (flag) {
          newMenu.push(item1);
        }
      }
      state.menuAll = newMenu;
      setStore({name: 'menuAll', content: state.menuAll})
    },
    SET_REFRESH_TOKEN: (state, refreshToken) => {
      setRefreshToken(refreshToken)
      state.refreshToken = refreshToken;
      setStore({name: 'refreshToken', content: state.refreshToken})
    },
    SET_TENANT_ID: (state, tenantId) => {
      state.tenantId = tenantId;
      setStore({name: 'tenantId', content: state.tenantId})
    },
    SET_USER_INFO: (state, userInfo) => {
      if (validatenull(userInfo.avatar)) {
        userInfo.avatar = "/img/bg/img-logo.png";
      }
      state.userInfo = userInfo;
      setStore({name: 'userInfo', content: state.userInfo})
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSION: (state, permission) => {
      let result = [];

      function getCode(list) {
        list.forEach(ele => {
          if (typeof (ele) === 'object') {
            const chiildren = ele.children;
            const code = ele.code;
            if (chiildren) {
              getCode(chiildren)
            } else {
              result.push(code);
            }
          }
        })
      }

      getCode(permission);
      state.permission = {};
      result.forEach(ele => {
        state.permission[ele] = true;
      });
      setStore({name: 'permission', content: state.permission})
    },
    SET_USER_TENANT: (state, list) => {
      state.userTenantList = list
      if(list.length <= 0) {
        this.$toast("登录时，请求的项目角色列表长度为0")
        return
      }
      let currUserTenant = {
        tenantId: list[0].tenantId,
        tenantName: list[0].tenantName,
      }
      setStore({name: 'userTenantList', content: state.userTenantList})
      setStore({name: 'currUserTenant', content: currUserTenant})
    }
  }

}
export default user



// WEBPACK FOOTER //
// ./src/store/modules/user.js